(function () {
  'use strict';

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  var section = document.querySelector('.cn-logo-scroll');
  if (!section) return;

  var topTrack = section.querySelector('.cn-logo-scroll__row:not(.cn-logo-scroll__row--reverse) .cn-logo-scroll__track');
  var bottomTrack = section.querySelector('.cn-logo-scroll__row--reverse .cn-logo-scroll__track');

  var speed = section.dataset.speed || 'slow';
  var totalShift = speed === 'fast' ? 2800 : speed === 'medium' ? 2000 : 1200;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var proxy = { shift: 0 };
  var coastTween = null;

  // Measure how far the originals are from the track's left edge (= pre-clone width).
  // offsetLeft is layout-based (not transform-based) so it's safe to read at any time.
  // position: relative on the track makes it the offsetParent for its items.
  function getOriginOffset(track) {
    var el = track.querySelector('[data-origin]');
    return el ? el.offsetLeft : 0;
  }

  var topOffset = getOriginOffset(topTrack);
  var bottomOffset = getOriginOffset(bottomTrack);

  // Top row:    x = -(originOffset + shift)  → shifts left as progress rises
  // Bottom row: x = -(originOffset - shift)  → shifts right as progress rises
  // Both always stay negative (no empty gap), originals are centred in the range.
  function applyShift() {
    if (topTrack) gsap.set(topTrack, { x: -(topOffset + proxy.shift) });
    if (bottomTrack) gsap.set(bottomTrack, { x: -(bottomOffset - proxy.shift) });
  }

  // quickTo is GSAP's optimised "frequently updated destination" tween —
  // cheaper than calling gsap.to() with overwrite on every scroll event.
  var quickShiftTo = gsap.quickTo(proxy, 'shift', {
    duration: 0.6,
    ease: 'power2.out',
    onUpdate: applyShift
  });

  var st = ScrollTrigger.create({
    trigger: section,
    start: 'top bottom',
    end: 'bottom top',
    onUpdate: function (self) {
      // Cancel any ongoing coast so scroll always wins.
      if (coastTween) { coastTween.kill(); coastTween = null; }
      quickShiftTo((self.progress - 0.5) * totalShift);
    }
  });

  // scrollEnd fires once the user has fully stopped scrolling.
  window.addEventListener('resize', function () {
    topOffset = getOriginOffset(topTrack);
    bottomOffset = getOriginOffset(bottomTrack);
  }, { passive: true });

  ScrollTrigger.addEventListener('scrollEnd', function () {
    // Only coast while the section is within the scroll range.
    if (st.progress <= 0 || st.progress >= 1) return;
    if (coastTween) coastTween.kill();

    // st.getVelocity() returns scroll px/s at the moment scrolling stopped.
    // Convert that to shift px, then ease it out over 2 seconds.
    var scrollVelocity = st.getVelocity();
    var extraShift = (scrollVelocity / (window.innerHeight + section.offsetHeight)) * totalShift * 0.7;

    coastTween = gsap.to(proxy, {
      shift: proxy.shift + extraShift,
      duration: 2,
      ease: 'power3.out',
      onUpdate: applyShift
    });
  });
})();
